var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.windowBreakpoint > 2)?_c('ThumbnailSlotSmallHorizontal'):_c('ThumbnailSlotSmallVertical')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }